export const processDeviceData = (deviceData, translateFn) => {
  if (!deviceData?.data) return [];

  const filteredDevices = deviceData.data.filter((object) => object?.id !== 4);

  const iphoneDevices = deviceData.data
    .filter((item) => item?.id === 4)
    .map((object) => ({
      id: 0,
      name: object?.name,
      supportedDevicesResponseList: object?.supportedDevicesResponseList,
    }));

  const slicedDevices = filteredDevices.map((item, index) => ({
    id: index + 1,
    name: item?.name,
    supportedDevicesResponseList: item?.supportedDevicesResponseList,
  }));

  const fullDevices = [...iphoneDevices, ...slicedDevices];

  const translatedIndex = fullDevices.findIndex(
    (item) => item?.name?.toLowerCase() === 'other',
  );

  if (translatedIndex >= 0) {
    fullDevices[translatedIndex].name = translateFn('esim:common.other');
  }

  return fullDevices;
};
